import { Outlet, Navigate } from "react-router-dom"
import Cookies from "js-cookie"

export const IsAuth = () => Cookies.get('payload') ? <Navigate to="/" replace={true} /> : <Outlet />